var throttle = require('lodash.throttle');

(function ($) {
	var $searchToggle = $('#search-toggle');
	var $search = $('.search');
    var $searchField = $search.find('input');
	var $searchButton = $search.find('.search__button');
	var $searchOverlay = $('.search__overlay');
	var searchIsOpen = false;

	function init() {

        $searchToggle.on('click', function (e) {
        	e.preventDefault();
			e.stopPropagation();

			if (searchIsOpen) {
				closeSearch();
			} else {
				openSearch();
			}
        });

	    $('.js-toggle-mobile-menu').on('click', function () {
		    if (searchIsOpen) {
			    closeSearch();
		    }
	    });

        $('body').on('click', function (e) {
            if (searchIsOpen === false || hasDesktopLook() === false) {
                return;
			}

		    e.stopPropagation();

            var $target = $(e.target);

            if ($search.has($target).length === 0) {
	            closeSearch();
            }
        });

        $searchOverlay.on('click', closeSearch);

	    $(window).on('scroll', throttle(handleScroll, 200));
    }

	function handleScroll() {
		if (hasDesktopLook()) {
			return;
		}

        if (searchIsOpen && $(window).scrollTop() > $('.header-section').outerHeight()) {
            closeSearch();
	        $searchField.blur();
		}
    }

    function hasDesktopLook() {
		return $(window).width() > 1140;
	}

    function toggleButtonState() {
		$searchToggle.fadeOut(50, function () {
			$searchToggle.toggleClass('search__toggle--open');
			$searchToggle.fadeIn(200);
        });

	    $searchButton.toggleClass('search__button--open');
    }

    function closeSearch() {
		if (hasDesktopLook()) {
			$search.animate({ width: 'toggle' }, 250);
		} else {
			$search.slideUp(250);
        }

	    $searchOverlay.fadeOut(250);
	    $searchField.prop('placeholder', '');
	    toggleButtonState();
		searchIsOpen = false;
		$searchToggle.attr('aria-expanded', 'false');
    }

    function openSearch() {
		var setPlaceholder = function () {
			var placeholder = $searchField.data('placeholder');
			$searchField.prop('placeholder', placeholder);
		};

		if (hasDesktopLook()) {
			$search.animate({ width: 'toggle' }, 250, function() {
				setPlaceholder();
			});
			$search.show();
		} else {
			setPlaceholder();
            $search.slideDown(250);
		}

		$searchOverlay.fadeIn();
		toggleButtonState();
		$searchField.focus();
		searchIsOpen = true;
		$searchToggle.attr('aria-expanded', 'true');
	}

	init();
})(jQuery);
